export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_trademetric.png",
      alt: "Nome da extensão",
    },
    title: "Copy Trading Inteligente para Operações de Alta Performance",
    text: [
      "No Trademetric, conectamos tecnologia, dados e execução disciplinada para permitir que investidores acompanhem estratégias profissionais de day trade com transparência, controle e eficiência. ",
    ],
    testimonial: {
      text: "Consistência não é sorte. É método, tecnologia e gestão.",
      author: {
        name: "Trademetric Research Team",
        // picture: "https://i.pravatar.cc/150?img=70",
      },
    },
  },
  stats: {
    title: "Resultados construídos com método e escala",
    subtitle: "Tecnologia aplicada ao mercado financeiro em números",
    data: [
      {
        value: "24M",
        description: "De estratégias criadas",
      },
      {
        value: "300%",
        description: "De retorno histórico utilizando apenas robôs",
      },
      {
        value: "+10",
        description: "Anos de desenvolvimento contínuo em sistemas de trading",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da Trademetric?",
    subtitle: "Veja quais as principais vantagens dos robôs da Trademetric.",
    data: [
      {
        title: "Execução Automatizada",
        description: "Estratégias com regras claras de risco, drawdown e exposição.",
      },
      {
        title: "Gestão de Risco Integrada",
        description: "Estratégias com regras claras de risco, drawdown e exposição.",
      },
      {
        title: "Transparência Total ",
        description: "Acesso a métricas, histórico e comportamento das estratégias.",
      },
      {
        title: "Tecnologia Proprietária",
        description: "Infraestrutura desenvolvida internamente para performance e estabilidade.",
      },
      {
        title: "Diversificação Estratégica",
        description: "Múltiplas abordagens operando em diferentes condições de mercado.",
      },
      {
        title: "Escalabilidade",
        description: "Projetado para crescer com consistência, não para apostas pontuais. ",
      },
    ],
  },
  cta: {
    title: "Acompanhe estratégias profissionais com tecnologia e transparência",
    subtitle: "Começar no Copy Trade ",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Trademetric",
    col1: [
      "Somos uma empresa de tecnologia que alia criatividade e ciência para gerar valor real aos nossos clientes. Desenvolvemos soluções baseadas em dados, automação e engenharia financeira para transformar a forma como decisões de mercado são executadas. ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da Trademetric",
  },
  strategies: {
    title: "Modelos desenvolvidos com base em dados, gestão de risco e validação contínua.",
    heading: "Arquitetura de trading ao seu alcance ",
    subtitle:
      "Cada estratégia é construída a partir de lógica quantitativa, controle de risco e validação contínua em diferentes cenários de mercado.",
  },
  testimonials: [
    {
      text: "Finalmente encontrei uma solução de copy trade que prioriza método e gestão, não promessas irreais.",
      author: "Carlos M.",
      job: "Empresário ",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
    {
      text: "O diferencial do Trademetric está na transparência e na qualidade das estratégias. Tudo é muito bem estruturado.",
      author: "Renata S. ",
      job: "Investidora Autônoma",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
  ],
};
